<template>
  <h1 data-test="home-page-header" class="center-flex">
    Hello, {{ props.firstName }}
    <img
      src="../assets/wave-emoji.png"
      class="wave-emoji"
      alt="wave emoji"
      data-test="wave-emoji"
    />
  </h1>
</template>

<script setup lang="ts">
const props = defineProps<{ firstName: string }>();
</script>

<style scoped lang="less">
@keyframes wave {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(20deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

h1 {
  margin: 10px 0 40px;
}

.wave-emoji {
  animation-name: wave;
  animation-duration: 0.5s;
  animation-delay: 0.5s;
  animation-iteration-count: 2;
  height: 1.1em;
  margin-left: 0.3em;
  margin-bottom: 0.3em;
}
</style>
